import React, { Component } from 'react';
import withTranslations from '../../../utils/HighOrderComponent';

class ComplementSignetRowHistory extends Component {
  render() {
    const { index, complementSignet } = this.props || {},
      { description, creator, createdAt } = complementSignet,
      { firstName, lastName } = creator || '';

    const fullName = firstName && lastName ? firstName + ' ' + lastName : '';

    const complementSignetRowHistory = (
      <tr className="text-center">
        <td>{index}</td>
        <td>{description}</td>
        <td>{fullName}</td>
        <td>{createdAt}</td>
      </tr>
    );

    return complementSignetRowHistory;
  }
}

export default withTranslations(
  ComplementSignetRowHistory,
  'ComplementSignetRowHistory'
);
